export default __webpack_public_path__ + "static/media/figjamIcon.96b86d8c.svg";